module.exports = __webpack_public_path__ + "static/media/TS-asset7.d262508d.svg";